module.exports = __webpack_public_path__ + "static/media/steptwo.231137e0.png";